// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__NONHj","additionalInfo":"AgreementModal_additionalInfo__3llpD"};